import { useState, useEffect, useCallback } from 'react';

const SLIDES = [
  {
    bg: 'https://cdn1.npcdn.net/images/1709694091banner1.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1600&new_height=1600&size=max&w=1735522370&from=jpg&off_wm=1',
    model: 'https://www.newpages2u.com/userfiles/25709/image/banner1-img(2).png',
    heading: 'Fashion/ Beauty\nMake Up Service',
    sub: 'Professional Makeup & Styling',
    href: '#services',
  },
  {
    bg: 'https://cdn1.npcdn.net/images/1707098639banner2.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1600&new_height=1600&size=max&w=1735522370&from=jpg&off_wm=1',
    model: 'https://www.newpages2u.com/userfiles/25709/image/banner2-img(1).png',
    heading: 'Celebrity/ KOL\nMakeup & Hair',
    sub: 'Professional Makeup & Styling',
    href: '#services',
  },
  {
    bg: 'https://cdn1.npcdn.net/images/1707099329banner3.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1600&new_height=1600&size=max&w=1735522370&from=jpg&off_wm=1',
    model: 'https://www.newpages2u.com/userfiles/25709/image/banner3-img(1).png',
    heading: 'Wedding/ Bridal\nMakeup & Hair',
    sub: 'Professional Makeup & Styling',
    href: '#services',
  },
];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback((idx: number) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 300);
  }, [animating]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = SLIDES[current];

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full overflow-hidden h-[300px] sm:h-[420px] md:h-[560px] lg:h-[640px]">
      {/* Background image */}
      <div className={`absolute inset-0 transition-opacity duration-500 ${animating ? 'opacity-0' : 'opacity-100'}`}>
        <img
          src={slide.bg}
          alt="banner background"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Content overlay */}
      <div className={`absolute inset-0 flex items-center transition-opacity duration-500 ${animating ? 'opacity-0' : 'opacity-100'}`}>
        <div className="w-full px-6 sm:px-10 md:px-12 flex items-center justify-between">
          {/* Left: Text */}
          <div className="flex-1 text-right pr-4 sm:pr-8 z-10">
            <h2
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 leading-tight mb-2 sm:mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {slide.heading.split('\n').map((line, i) => (
                <span key={i}>{line}{i < slide.heading.split('\n').length - 1 && <br />}</span>
              ))}
            </h2>
            <p className="text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] uppercase text-gray-600 mb-4 sm:mb-6">{slide.sub}</p>
            <a
              href={slide.href}
              onClick={e => { e.preventDefault(); handleNav(slide.href); }}
              className="inline-block border border-gray-800 text-gray-800 px-4 sm:px-8 py-1.5 sm:py-2 text-xs sm:text-sm tracking-widest uppercase hover:bg-gray-800 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {slide.sub}
            </a>
          </div>

          {/* Right: Model image */}
          <div className="flex-1 flex justify-center items-end h-[260px] sm:h-[380px] md:h-[520px] lg:h-[600px]">
            <img
              src={slide.model}
              alt="model"
              className="h-full w-full object-contain object-bottom"
            />
          </div>
        </div>
      </div>

      {/* Arrows */}
      <button
        onClick={() => goTo((current - 1 + SLIDES.length) % SLIDES.length)}
        className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/60 hover:bg-white/90 transition-all cursor-pointer rounded-full"
      >
        <i className="ri-arrow-left-s-line text-lg sm:text-xl text-gray-700" />
      </button>
      <button
        onClick={() => goTo((current + 1) % SLIDES.length)}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/60 hover:bg-white/90 transition-all cursor-pointer rounded-full"
      >
        <i className="ri-arrow-right-s-line text-lg sm:text-xl text-gray-700" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`h-2 sm:h-2.5 rounded-full transition-all cursor-pointer ${i === current ? 'bg-gray-800 w-5 sm:w-6' : 'bg-gray-400 w-2 sm:w-2.5'}`}
          />
        ))}
      </div>
    </section>
  );
}
